'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LINK_TO_LIVE_CHAT_INFO = exports.BROWSER_NOTIFICATION_BLOCKED_HELPDOC = exports.LINK_TO_HELP_PAGE = exports.LINK_TO_SIGN_UP_PAGE = exports.ONLINE_OFFLINE_ACADEMY_LINK = exports.PATH_OPTIONS = exports.CHAT_PATH = exports.EDIT_PATH = exports.CREATE_PATH = exports.SETTINGS_PATH = exports.ONBOARDING_PATH = exports.SIGN_UP_PATH = exports.INDEX_PATH = exports.getSettingsRootUrl = exports.getRootUrl = exports.getSettingsBaseUrl = exports.getBaseUrl = undefined;
exports.getPublishingUrl = getPublishingUrl;
exports.doesPathContain = doesPathContain;
exports.getSubscreen = getSubscreen;
exports.getPath = getPath;
exports.getContactLink = getContactLink;
exports.linkToCRMTab = linkToCRMTab;
exports.linkToUserPreferences = linkToUserPreferences;
exports.linkToSalesDashboard = linkToSalesDashboard;
exports.linkToMeetings = linkToMeetings;

var _hubspot = require('hubspot.PortalIdParser');

var _hubspot2 = _interopRequireDefault(_hubspot);

var _immutable = require('immutable');

var _enviro = require('enviro');

var _enviro2 = _interopRequireDefault(_enviro);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var envSuffix = function envSuffix() {
  return _enviro2.default.getInternal('api') === 'qa' ? 'qa' : '';
};
var getBaseUrl = exports.getBaseUrl = function getBaseUrl() {
  return '/live-messages';
};
var getSettingsBaseUrl = exports.getSettingsBaseUrl = function getSettingsBaseUrl() {
  return '/live-messages-settings';
};

var getRootUrl = exports.getRootUrl = function getRootUrl() {
  return getBaseUrl() + '/' + _hubspot2.default.get();
};
var getSettingsRootUrl = exports.getSettingsRootUrl = function getSettingsRootUrl() {
  return getSettingsBaseUrl() + '/' + _hubspot2.default.get();
};

var INDEX_PATH = exports.INDEX_PATH = '';
var SIGN_UP_PATH = exports.SIGN_UP_PATH = 'signup';
var ONBOARDING_PATH = exports.ONBOARDING_PATH = 'onboarding';
var SETTINGS_PATH = exports.SETTINGS_PATH = 'settings';
var CREATE_PATH = exports.CREATE_PATH = 'create';
var EDIT_PATH = exports.EDIT_PATH = 'edit';
var CHAT_PATH = exports.CHAT_PATH = 'chat';

var PATH_OPTIONS = exports.PATH_OPTIONS = (0, _immutable.List)([CREATE_PATH, SETTINGS_PATH, EDIT_PATH, SIGN_UP_PATH, CHAT_PATH, ONBOARDING_PATH]);

var ONLINE_OFFLINE_ACADEMY_LINK = exports.ONLINE_OFFLINE_ACADEMY_LINK = 'https://knowledge.hubspot.com/articles/kcs_article/messages/how-to-setup-messages';

var LINK_TO_SIGN_UP_PAGE = exports.LINK_TO_SIGN_UP_PAGE = 'http://www.hubspot.com/products/messages-beta?pql-source=Messages-Beta';

var LINK_TO_HELP_PAGE = exports.LINK_TO_HELP_PAGE = 'https://knowledge.hubspot.com/articles/kcs_article/messages/how-to-setup-messages';

var BROWSER_NOTIFICATION_BLOCKED_HELPDOC = exports.BROWSER_NOTIFICATION_BLOCKED_HELPDOC = 'https://knowledge.hubspot.com/articles/kcs_article/messages/why-am-i-not-receiving-push-notifications-for-messages-in-my-browser';

var LINK_TO_LIVE_CHAT_INFO = exports.LINK_TO_LIVE_CHAT_INFO = 'https://www.hubspot.com/products/sales/live-chat';

function getPublishingUrl() {
  return 'https://app.hubspot' + envSuffix() + '.com/content/' + _hubspot2.default.get() + '/settings/publishing';
}

function doesPathContain(path, route) {
  return path.indexOf(route) > -1;
}

function getSubscreen(path) {
  return PATH_OPTIONS.find(function (pathType) {
    return doesPathContain(path, pathType);
  }) || 'index';
}

function getPath(subpath) {
  return getRootUrl() + '/' + subpath;
}

function getContactLink(vid) {
  return 'https://app.hubspot' + envSuffix() + '.com/sales/' + _hubspot2.default.get() + '/contact/' + vid + '/';
}

function linkToCRMTab(vid, tab) {
  var url = 'https://app.hubspot' + envSuffix() + '.com/sales/' + _hubspot2.default.get() + '/contact/' + vid;

  if (tab !== null) {
    url += '?interaction=' + tab;
  }
  return url;
}

function linkToUserPreferences() {
  return 'https://app.hubspot' + envSuffix() + '.com/user-preferences/' + _hubspot2.default.get();
}

function linkToSalesDashboard() {
  return 'https://app.hubspot' + envSuffix() + '.com/reports-dashboard/' + _hubspot2.default.get() + '/sales';
}

function linkToMeetings() {
  return 'https://app.hubspot' + envSuffix() + '.com/meetings/' + _hubspot2.default.get() + '/';
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-lib/static-1.28/js/urls.js
// module id = 200
// module chunks = 0 1